export const ProtectionPrefix = 'protection:';

export const Protection = {
  NONE: `${ProtectionPrefix}none`,
  BASE: `${ProtectionPrefix}base`,
  FULL: `${ProtectionPrefix}full`
};
export const ProtectionOptions = Object.values(Protection);

export const Label = {
  DRIVER: 'driverbringslabel',
  STORE: 'printinstore'
};
export const LabelOptions = Object.values(Label);

export const Date = {
  SAMEDAY: 'samedaycollection'
};
export const DateOptions = Object.values(Date);

export const Upsell = {
  SMS: 'smsalert',
  GUARANTEE: 'deliveryguarantee',
  SIGNATURE: 'signature'
};

export const DutyUpsell = {
  DDP: 'ddp'
};

export const OnDemandUpsells = [DutyUpsell.DDP];

export const UpsellOptions = Object.values(Upsell);

export const BasketUpsellOptions = [...LabelOptions, ...UpsellOptions];

export const OriginUpsells = [Upsell.SMS];

export const DestinationUpsells = [Upsell.GUARANTEE, Upsell.SIGNATURE];

export const QuoteUpsellOptions = [...OriginUpsells, ...DestinationUpsells];
